export default __webpack_public_path__ + "static/next@2x-735813e57a3c0f84726d2206af91d59f.png";